import { useState } from "react";
import { useNewFieldPrompt } from "../../stores/newFieldPrompt";
import { useFields } from "../../hooks/queries";
import { JdImportStep } from "../jd-import/JdImportStep";
import { JdLinkModal } from "../../components/JdLinkModal";
import type { DashboardField } from "../../types/contract";
import { Popup } from "../../ui/Popup";

export function NewFieldJdPrompt() {
  const pending = useNewFieldPrompt((s) => s.pending);
  const dismiss = useNewFieldPrompt((s) => s.dismiss);
  if (!pending) return null;
  return (
    <Prompt
      key={pending.field_id}
      field={pending}
      onClose={() => dismiss(pending.field_id)}
    />
  );
}

function Prompt({
  field,
  onClose,
}: {
  field: DashboardField;
  onClose: () => void;
}) {
  const [view, setView] = useState<"ask" | "jdlink">("ask");
  const { data: fields } = useFields();
  // read the LIVE field so a just-completed link (JdLinkModal invalidates the fields query) flips the
  // step from "Link…" to the import buttons instead of re-showing Link off the stale snapshot.
  const live = fields?.find((f) => f.field_id === field.field_id) ?? field;

  if (view === "jdlink")
    return (
      <JdLinkModal fieldId={field.field_id} onClose={() => setView("ask")} />
    );

  return (
    <Popup
      onClose={onClose}
      className="w-full max-w-md rounded-lg bg-surface text-fg shadow-2xl"
    >
      <JdImportStep
        field={live}
        title={`Add John Deere data for “${live.field_name}”?`}
        intro="This field was just added. You can pull in its John Deere machine + yield data now, so it collects alongside the other field data already loading — or skip and add it later from the map."
        onLink={() => setView("jdlink")}
        onDone={onClose}
        onSkip={onClose}
        onClose={onClose}
      />
    </Popup>
  );
}
